import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PdfPreviewData } from '../interface/pdf-preview-data.interface';

/**
 * Modal para previsualizar PDFs de liquidaciones
 *
 * @remarks
 * - Muestra el PDF en un iframe seguro
 * - Permite cerrar el modal con botón o tecla Escape
 * - Soporta modo de validación con botón integrado
 */
@Component({
  selector: 'app-pdf-preview-modal',
  templateUrl: './pdf-preview-modal.component.html',
  styleUrls: ['./pdf-preview-modal.component.scss']
})
export class PdfPreviewModalComponent {
  safePdfUrl: SafeResourceUrl;
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PdfPreviewData,
    private readonly dialogRef: MatDialogRef<PdfPreviewModalComponent>,
    private readonly sanitizer: DomSanitizer
  ) {
    this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.pdfUrl);
  }

  /**
   * Cierra el modal sin validar
   */
  cerrar(): void {
    this.dialogRef.close(false);
  }

  /**
   * Valida la liquidación y cierra el modal
   */
  validar(): void {
    this.dialogRef.close(true);
  }

  /**
   * Maneja el evento de carga del iframe
   */
  onIframeLoad(): void {
    this.loading = false;
  }
}
